import { Injector, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import utils from './utils/index';
import { HOME } from '../app.constants';

export class BaseNewComponents implements OnInit {
    constructor(protected injector: Injector) {
        this.router = injector.get(Router);
        this.toast = injector.get(ToastrService);
        this.route = injector.get(ActivatedRoute);
    }
    protected router: Router;
    protected toast: ToastrService;
    protected route: ActivatedRoute;

    isMobile = utils.screens.isMobile;
    currentGridSize = utils.screens.currentGridSize;

    ngOnInit() {
    }

    isMaintenance() {
        return utils.isMaintenance();
    }

    goTo(url: string = '') {
        if (this.isMobile()) {
            this.goToExternalUrl(`${HOME}/${url}`, '_top');
            return;
        }
        this.router.navigate([url]);
    }
    goToCart() {
        const {notAvailable = false, message = '', title = ''} = this.isMaintenance();
        // TODO LEMBRAR DE TIRAR
        console.log('gotToCart => notAvailable => ', notAvailable);
        if (notAvailable) {
            this.toast.error(message, title, { timeOut: 5000});
            return;
        }
        this.goTo('faca-parte');
    }


    goToCommunity() {
        this.goTo('comunidade');
    }

    goToBlog() {
        const utmSource = 'utm_source=Site+para+blog';
        const utmMedium = 'utm_medium=Blog+da+Montreal';
        const utmID = 'utm_id=Direcionamento+do+site+Montreal+para+o+Blog';
        const blogUrl = `https://www.viagensmontreal.com/blog/?${utmSource}&${utmMedium}&${utmID}`;
        this.goToExternalUrl(blogUrl);
    }

    goToHotels() {
        this.goToExternalUrl('https://montrealviagens.my.site.com/listagemhoteis/s/');
    }

    goToPlans() {
        this.goToExternalUrl('https://clube.viagensmontreal.com/planos-montreal/');
    }

    goToExternalUrl(link: string, target: string = '_blank') {
        if (typeof window !== 'undefined') {
            window.open(link, target);
        }
    }
}
